export function SantaConfirmModal({
  lang, darkMode,
  santaBudget, setSantaBudget,
  setShowSantaConfirm, activateSantaSecreto, tr,
}) {
  return (
    <div className="modal-overlay" onClick={function(e) { if (e.target === e.currentTarget) setShowSantaConfirm(false); }}>
      <div className="modal" style={{ textAlign: "center" }}>
        <div style={{ fontSize: 52, marginBottom: 12 }}>🎅</div>
        <h3 style={{ fontFamily: "Playfair Display, serif", fontSize: 20, marginBottom: 8 }}>{tr("santaSecretTitle")}</h3>
        <p style={{ fontSize: 14, color: "#999", marginBottom: 20 }}>{tr("santaSecretConfirm")}</p>
        <div className="campo">
          <label className="campo-label">{tr("santaSecretBudget")} ({tr("santaSecretNoBudget")})</label>
          <input
            className="campo-input"
            placeholder="ej. 500"
            value={santaBudget}
            onChange={function(e) { setSantaBudget(e.target.value.replace(/\D/g, "")); }}
            style={{ textAlign: "center", fontSize: 20 }}
          />
        </div>
        <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
          <button
            className="btn btn-full"
            style={{ background: "linear-gradient(135deg, #c0392b, #e74c3c)", color: "#fff", border: "none", flex: 1 }}
            onClick={activateSantaSecreto}
          >
            {tr("santaSecretYes")}
          </button>
          <button className="btn btn-gris" onClick={function() { setShowSantaConfirm(false); }}>
            {tr("santaSecretCancel")}
          </button>
        </div>
      </div>
    </div>
  );
}

export function SantaEnvelopeModal({
  lang, currentFamily,
  santaRevealName, setShowSantaEnvelope, tr,
}) {
  return (
    <div className="modal-overlay" onClick={function(e) { if (e.target === e.currentTarget) setShowSantaEnvelope(false); }}>
      <div className="modal" style={{ textAlign: "center" }}>
        <div style={{ fontSize: 56, marginBottom: 8 }}>🎁</div>

        {Array.isArray(santaRevealName) ? (
          <>
            {santaRevealName.map(function(r, i) {
              return (
                <div key={i} style={{ marginBottom: 16, padding: "12px 16px", background: i % 2 === 0 ? "#fff8f8" : "#fff", borderRadius: 12, border: "1px solid #fdd" }}>
                  {!r.isMe && <div style={{ fontSize: 12, color: "#999", marginBottom: 4 }}>{r.gifterName} →</div>}
                  {r.isMe && <div style={{ fontSize: 12, color: "#999", marginBottom: 4 }}>{tr("santaSecretYouGot")}</div>}
                  <div style={{ fontFamily: "Playfair Display, serif", fontSize: 28, color: "#c0392b", fontWeight: 700 }}>{r.recipientName}</div>
                </div>
              );
            })}
          </>
        ) : (
          <>
            <h3 style={{ fontFamily: "Playfair Display, serif", fontSize: 18, color: "#999", marginBottom: 4 }}>{tr("santaSecretYouGot")}</h3>
            <div style={{ fontFamily: "Playfair Display, serif", fontSize: 36, color: "#c0392b", fontWeight: 700, marginBottom: 8 }}>{santaRevealName}</div>
          </>
        )}

        {currentFamily?.santaSecreto?.budget && (
          <div style={{ fontSize: 13, color: "#999", marginBottom: 12 }}>
            🎄 {tr("santaSecretBudget")}: <strong>${currentFamily.santaSecreto.budget}</strong>
          </div>
        )}
        <p style={{ fontSize: 13, color: "#bbb", marginBottom: 16 }}>¡Shhh! 🤫</p>
        <button className="btn btn-negro btn-full" onClick={function() { setShowSantaEnvelope(false); }}>
          {tr("confirm")}
        </button>
      </div>
    </div>
  );
}
